// extracted by mini-css-extract-plugin
module.exports = {"tittle":"activities_tittle__2Zdga","container":"activities_container__21lF7","cancel":"activities_cancel__1Uvtw","icon":"activities_icon__18F9x"};